import { get } from "lodash";
import {
  PPE_ALERT_STATUS,
  PPE_ALERT_TYPE,
  PPE_PERSON_STATUS,
  RELATIONSHIP,
} from "utils/constants";

const cleanPersonName = (value) => {
  const text = String(value ?? "").trim();
  if (!text || text.toLowerCase() === "null") return "";
  return text;
};

export const hasFirstAndLastName = (person) => {
  const firstName = cleanPersonName(get(person, "kayrosData.prenom"));
  const lastName = cleanPersonName(get(person, "kayrosData.nom"));
  if (firstName && lastName) return true;
  const parts = String(person?.fullName || "")
    .split(/\s+/)
    .map(cleanPersonName)
    .filter(Boolean);
  return parts.length >= 2;
};

export const isNamedHouseholdMember = (relatedPerson) => {
  const relationship = get(relatedPerson, "relationship");
  const firstName = cleanPersonName(
    get(relatedPerson, "identity.user.firstname"),
  );
  const lastName = cleanPersonName(
    get(relatedPerson, "identity.user.lastname"),
  );
  return (
    (relationship === RELATIONSHIP.SPOUSE ||
      relationship === RELATIONSHIP.CHILD) &&
    Boolean(firstName) &&
    Boolean(lastName)
  );
};

export const computePersonStatus = (alerts = []) => {
  if (!alerts || alerts.length === 0) return PPE_PERSON_STATUS.VERIFIED;

  const hasConfirmedGEL = alerts.some(
    (a) =>
      a.type === PPE_ALERT_TYPE.GELS_SANCTIONS &&
      a.status === PPE_ALERT_STATUS.CONFIRMED,
  );
  if (hasConfirmedGEL) return PPE_PERSON_STATUS.BLOCKED;

  const hasPending = alerts.some((a) => a.status === PPE_ALERT_STATUS.PENDING);
  if (hasPending) return PPE_PERSON_STATUS.ALERT;

  return PPE_PERSON_STATUS.VERIFIED;
};

export const isHouseholdBlocked = (persons = []) => {
  return persons.some((person) =>
    (person.alerts || []).some(
      (a) =>
        a.type === PPE_ALERT_TYPE.GELS_SANCTIONS &&
        a.status === PPE_ALERT_STATUS.CONFIRMED,
    ),
  );
};

export const getBlockingPersonName = (persons = []) => {
  for (const person of persons) {
    const hasConfirmedGEL = (person.alerts || []).some(
      (a) =>
        a.type === PPE_ALERT_TYPE.GELS_SANCTIONS &&
        a.status === PPE_ALERT_STATUS.CONFIRMED,
    );
    if (hasConfirmedGEL) return person.fullName;
  }
  return null;
};
